import HeroSection from '../components/HeroSection';
import AppDownloadSection from '../components/AppDownloadSection';
import PremiumEventsSection from '../components/PremiumEventsSection';
import SponsorMarquee from '../components/SponsorMarquee';
import FeaturedEvents from '../components/FeaturedEvents';
import SubscriptionSection from '../components/SubscriptionSection';

const Home = () => {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <AppDownloadSection />
      <PremiumEventsSection />
      <SponsorMarquee />
      <FeaturedEvents />
      <SubscriptionSection />
    </div>
  );
};

export default Home;
